const ERROR_MAX_LENGTH = 300;

export const getErrorMessageFromAPI = ({ response }, customMessage) => {
  if (response?.data?.Message) {
    return response?.data?.Message;
  }
  if (response?.data?.message) {
    return response?.data?.message;
  }
  if (response?.data?.error) {
    return response?.data?.error;
  }
  return response?.data?.length < ERROR_MAX_LENGTH ? response?.data : customMessage ? customMessage : false;
};
